module.exports = __webpack_public_path__ + "static/media/newgen.65b02293.png";